import { ModernAPI } from 'Modules/ModernAPI'
import { authHeaders } from 'Modules/API'
import { refetchUser } from './authSlice'
import { authActions } from './authSlice'

const API_BASE = window.HMI_API_BASE || process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api'
const getAuthToken = () => window.localStorage.getItem('HMI_AUTH_TOKEN')

export const addPrimaryPhone = (phone, history) => dispatch => {
    const token = getAuthToken()
    if (token) {
        return fetch(`${API_BASE}/users/phone`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ phone: phone.number, countryCode: phone.countryCode })
        })
            .then(res => {
                if (!res.ok) return res.text().then(text => { throw new Error(`HTTP ${res.status}: ${text}`) })
                return res.json()
            })
            .then(() => {
                dispatch(refetchUser())
                if (history) history.push('/my-profile')
            })
    }
    return ModernAPI.addBasicPropsToProfile(phone)
        .then(() => {
            dispatch(refetchUser())
            if (history) history.push('/my-profile')
        })
}

export const initPhoneVerification = (phoneObject) => (dispatch, getState) => {
    const { auth: { currentUser: user } } = getState()
    const givenName = user.profile.properties.find(p => p.name === 'givenName')
    const familyName = user.profile.properties.find(p => p.name === 'familyName')
    return ModernAPI.sendVerifyBySMS({
        username: user.username,
        givenName: givenName ? givenName.value : '',
        familyName: familyName ? familyName.value : '',
        phone: phoneObject.parameters[1].value,
        countryCode: phoneObject.parameters[2].value
    })
}

export const verifyPhone = (phoneObject, code) => (dispatch, getState) => {
    const { auth: { currentUser: user } } = getState()
    return ModernAPI.verifyInitialSMSCode({
        username: user.username,
        phone: phoneObject.parameters[1].value,
        countryCode: phoneObject.parameters[2].value,
        code
    }).then(() => dispatch(refetchUser()))
}

export const setPropertyInCard = (cardId, propIdOrName, add) => (dispatch, getState) => {
    try {
        const state = getState()
        const currentProfile = state?.auth?.currentUser?.profile
        console.log('setPropertyInCard: Starting with cardId:', cardId, 'propIdOrName:', propIdOrName, 'add:', add)
        console.log('setPropertyInCard: Current profile cards:', currentProfile?.cards?.map(c => ({ id: c.objectId, name: c.name, properties: c.properties?.length })))

        if (currentProfile && Array.isArray(currentProfile.cards) && Array.isArray(currentProfile.properties)) {
            const nextProfile = JSON.parse(JSON.stringify(currentProfile))
            const cardIdx = nextProfile.cards.findIndex(c => c.objectId === cardId)
            const baseProp = nextProfile.properties.find(p => p.objectId === propIdOrName || p.name === propIdOrName)
            console.log('setPropertyInCard: Found card at index:', cardIdx, 'Found property:', baseProp?.name)

            if (cardIdx !== -1 && baseProp) {
                const card = nextProfile.cards[cardIdx]
                const has = card.properties?.some(p => p.objectId === baseProp.objectId || p.name === baseProp.name)
                console.log('setPropertyInCard: Property currently has:', has)

                card.properties = Array.isArray(card.properties) ? card.properties.slice() : []
                if (add && !has) {
                    card.properties.push(baseProp)
                    console.log('setPropertyInCard: Added property to card')
                } else if (!add && has) {
                    card.properties = card.properties.filter(p => (p.objectId !== baseProp.objectId && p.name !== baseProp.name))
                    console.log('setPropertyInCard: Removed property from card')
                }
                nextProfile.cards[cardIdx] = card
                console.log('setPropertyInCard: Updated card properties count:', card.properties.length)
                dispatch(authActions.updateProfile(nextProfile))

                // Set flag to prevent refetchUser from overwriting our optimistic update
                dispatch({ type: 'SET_OPTIMISTIC_UPDATE_IN_PROGRESS', payload: true })
            }
        }
    } catch (_) { }

    return fetch(`${API_BASE}/cards/property-simple`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ cardId, propertyId: propIdOrName, add })
    })
        .then(res => {
            if (!res.ok) return res.text().then(text => { throw new Error(`HTTP ${res.status}: ${text}`) })
            return res.json()
        })
        .then((data) => {
            console.log('setPropertyInCard: API response data:', data)
            if (!data || !data.success) throw new Error(data?.error?.message || 'Failed to update card property')

            // Clear the optimistic update flag
            dispatch({ type: 'SET_OPTIMISTIC_UPDATE_IN_PROGRESS', payload: false })

            if (data.profile) {
                console.log('setPropertyInCard: Server returned profile, but IGNORING it to preserve optimistic UI')
                console.log('setPropertyInCard: Optimistic update is working, keeping it instead of server data')
                // Don't update Redux store with server profile - keep the optimistic update
                // Don't call refetchUser() to preserve the optimistic update
                return data
            }
            console.log('setPropertyInCard: Server did not return profile, keeping optimistic UI')
            // If server doesn't return a profile, keep optimistic UI without refetch
            return data
        })
        .catch(error => {
            // Clear the optimistic update flag on error
            dispatch({ type: 'SET_OPTIMISTIC_UPDATE_IN_PROGRESS', payload: false })
            return dispatch(refetchUser()).then(() => { throw error })
        })
}


export const setProfileProperty = (name, value, id) => (dispatch, getState) => {
    // OPTIMISTIC UPDATE: Update Redux state immediately for instant UI feedback
    try {
        const state = getState()
        const currentUser = state?.auth?.currentUser
        if (currentUser && currentUser.profile && currentUser.profile.properties) {
            const nextProfile = JSON.parse(JSON.stringify(currentUser.profile))
            const propertyIndex = nextProfile.properties.findIndex(p => 
                (id && p.objectId === id) || (!id && p.name === name)
            )
            
            if (propertyIndex !== -1) {
                // Update existing property
                const property = nextProfile.properties[propertyIndex]
                // Extract value from parameters if it's an object, otherwise use the value directly
                let extractedValue = value
                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    // For complex properties, extract the value from the object structure
                    extractedValue = value.value || value.address || value.number || JSON.stringify(value)
                }
                
                // Update property value and parameters
                property.value = extractedValue
                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    // Update parameters structure
                    const parameters = {}
                    Object.keys(value).forEach(key => {
                        if (value[key] && typeof value[key] === 'object' && value[key].value !== undefined) {
                            parameters[key] = value[key]
                        } else {
                            parameters[key] = { name: key, value: value[key] }
                        }
                    })
                    property.parameters = parameters
                } else {
                    // Simple value update
                    property.parameters = { '1': { name: 'value', value: extractedValue }, '2': { name: 'type', value: 'text' } }
                }
                property.updatedAt = new Date().toISOString()
                
                nextProfile.properties[propertyIndex] = property
                nextProfile.updatedAt = new Date().toISOString()
                
                // Update Redux state immediately
                dispatch(authActions.updateProfile(nextProfile))
                console.log('✅ [OPTIMISTIC UPDATE] Updated property in Redux state:', name, extractedValue)
            } else {
                console.warn('⚠️ [OPTIMISTIC UPDATE] Property not found in profile:', name, id)
            }
        }
    } catch (optimisticError) {
        console.warn('⚠️ [OPTIMISTIC UPDATE] Failed to update Redux state:', optimisticError)
        // Continue with server update even if optimistic update fails
    }
    
    // Prepare request body for server
    let requestBody
    if ((name === 'postalAddresses' || name === 'emailAddresses' || name === 'urlAddresses' || name === 'phoneNumbers') && typeof value === 'object') {
        const parameters = {}
        Object.keys(value).forEach(key => {
            // Skip empty keys to avoid React warnings and server errors
            if (key !== '' && key != null && value[key] && typeof value[key] === 'object' && value[key].value !== undefined) {
                parameters[key] = value[key]
            }
        })
        requestBody = { parameters, verified: false }
    } else if (name === 'onmymind') {
        // Handle onmymind as a simple text property with parameters structure
        requestBody = { parameters: { '1': { name: 'value', value } }, verified: false }
    } else {
        requestBody = { parameters: { '1': { name: 'value', value }, '2': { name: 'type', value: 'text' } }, verified: false }
    }
    const isPlaceholder = id && id.includes('_') && !id.startsWith('prop_')
    const endpoint = (id && !isPlaceholder) ? `${API_BASE}/users/profile/properties/${encodeURIComponent(id)}` : `${API_BASE}/users/profile/properties/by-name/${encodeURIComponent(name)}`
    return fetch(endpoint, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(requestBody)
    })
        .then(res => { if (!res.ok) return res.text().then(text => { throw new Error(`HTTP ${res.status}: ${text}`) }); return res.json() })
        .then((data) => { 
            if (!data || !data.success) throw new Error(data?.error?.message || 'Failed to update profile property')
            // Sync with server after successful update
            // Add a small delay to ensure server cache is invalidated
            return new Promise(resolve => setTimeout(() => {
                dispatch(refetchUser()).then(() => resolve(data))
            }, 100))
        })
        .catch(error => {
            // On error, refetch to restore correct state
            console.error('❌ [PROFILE UPDATE] Server update failed, refetching to restore state:', error)
            return dispatch(refetchUser()).then(() => { throw error })
        })
}

export const addProperty = (name, value) => (dispatch) => {
    // Clean value object - remove empty keys if value is an object
    let cleanedValue = value
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        cleanedValue = {}
        Object.keys(value).forEach(key => {
            // Skip empty keys to avoid React warnings and server errors
            if (key !== '' && key != null && value[key] && typeof value[key] === 'object' && value[key].value !== undefined) {
                cleanedValue[key] = value[key]
            }
        })
    }
    return fetch(`${API_BASE}/users/profile/properties`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ name, value: cleanedValue })
    })
        .then(res => { if (!res.ok) return res.text().then(text => { throw new Error(`HTTP ${res.status}: ${text}`) }); return res.json() })
        .then((data) => { if (!data || !data.success) throw new Error(data?.error?.message || 'Failed to add profile property'); return dispatch(refetchUser()) })
}

export const deleteProperty = (propertyId) => (dispatch) => {
    return fetch(`${API_BASE}/users/profile/properties/${encodeURIComponent(propertyId)}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', ...authHeaders() }
    })
        .then(res => { if (!res.ok) return res.text().then(text => { throw new Error(`HTTP ${res.status}: ${text}`) }); return res.json() })
        .then((data) => { if (!data || !data.success) throw new Error(data?.error?.message || 'Failed to delete profile property'); return dispatch(refetchUser()) })
}

export const loadQRCodes = () => dispatch => {
    return ModernAPI.getQRCodes()
        .then(data => {
            console.log('QR Codes API Response:', data);
            const qrCodes = data.map(code => code.toJSON ? code.toJSON() : code)
            console.log('Processed QR Codes:', qrCodes);
            dispatch({ type: 'personal/qrCodeList', payload: { qrCodes } })
            return qrCodes
        })
        .catch(error => {
            console.error('QR Codes API Error:', error);
            throw error;
        })
}

export const updateQRCodeName = (id, name) => dispatch => {
    return ModernAPI.editQRName({ id, name })
        .then(code => {
            const qrCode = code.toJSON ? code.toJSON() : code
            dispatch({ type: 'QR_CODE_UPDATE', payload: { qrCode } })
            return qrCode
        })
}

export const createQRCode = (label, cardId) => dispatch => {
    return ModernAPI.createQRCode({ label, cardId })
        .then(qrCode => {
            dispatch({ type: 'personal/qrCodeCreate', payload: { qrCode } })
            return qrCode
        })
}

export const setQRCard = (cardId, QRCode) => dispatch => {
    return ModernAPI.setQRCard({ cardId, QRCode })
        .then(response => {
            // Extract the actual QR code data from the response
            // The API returns { success: true, data: qrCode } or just the qrCode directly
            let qrCodeData = response.data || response

            // If it's an array, extract the first element
            if (Array.isArray(qrCodeData)) {
                qrCodeData = qrCodeData[0]
            }

            // Update only the specific QR code in Redux state instead of replacing the entire list
            dispatch({ type: 'personal/qrCodeUpdate', payload: { qrCode: qrCodeData } })
            return qrCodeData
        })
        .catch(error => {
            console.error('setQRCard error:', error)
            throw error
        })
}

export const deleteQRCode = (id) => dispatch => {
    return ModernAPI.deleteQRCode({ id })
        .then(() => {
            dispatch({ type: 'personal/qrCodeDelete', payload: { id } })
            return true
        })
}

export const getSingleUser = (userId) => dispatch => {
    dispatch(authActions.getUserRequest())
    let user
    return ModernAPI.getUserWithProperties(userId)
        .then(res => { user = res.user || res; return ModernAPI.getConnectionsForUsers({ users: [userId], properties: ['fn'] }) })
        .then(res => {
            const connections = res.connections || res.data?.connections || []
            const names = res.properties || res.data?.properties || []
            dispatch(authActions.getUserSuccess(user, connections, names))
        })
        .catch(error => { dispatch(authActions.getUserFailure(error.message || error)) })
}

export const getConnections = () => dispatch =>
    ModernAPI.getConnectionsForUser().then(res => {
        if (Array.isArray(res)) return res;
        if (res && res.data && Array.isArray(res.data.connections)) return res.data.connections;
        if (res && Array.isArray(res.connections)) return res.connections;
        return [];
    })

export const getIncomingInvites = () => dispatch => ModernAPI.getIncomingInvitesForUser()
export const getOutgoingInvites = () => dispatch => ModernAPI.getOutGoingInvitesForUser()

export const verifyEmail = (messageId, token) => (dispatch, getState) =>
    ModernAPI.setPropertyVerified({ messageId, token }).then(res => {
        if (getState().auth.isAuthenticated) return dispatch(refetchUser()); else return res
    })

export function deleteCard(userId, cardId) {
    return (dispatch, getState) => {
        dispatch({ type: 'DELETE_CARD_START', cardId })
        return ModernAPI.deleteCard({ userId, cardId })
            .then(({ cardId, connections }) => {
                if (connections.length === 0) {
                    dispatch({ type: 'DELETE_CARD_SUCCESS', cardId })
                } else {
                    const them = connections.length > 1 ? 'everyone' : 'them'
                    const msg = 'This will disconnect ' + connections.length + ' user' + (connections.length > 1 ? 's.' : '.') + ' Please remove ' + them + ' from this card before deleting.'
                    dispatch({ type: 'DELETE_CARD_FAILURE', error: msg })
                }
                return cardId
            })
            .then(() => { dispatch(queryCards()) })
            .catch((error) => { dispatch({ type: 'DELETE_CARD_FAILURE', error }) })
    }
}

export function queryCards() {
    return dispatch => {
        dispatch({ type: 'CARD_QUERY_START' })
        return ModernAPI.getCardsWithConnections()
            .then(data => {
                const connections = {}
                const cards = data.cards.map(card => card.toJSON ? card.toJSON() : card)
                Object.entries(data.connections).forEach(conn => {
                    if (conn[1].length && conn[1].length !== 0) {
                        connections[conn[0]] = conn[1].map(co => co.toJSON ? co.toJSON() : co)
                    }
                })
                dispatch({ type: 'CARD_QUERY_SUCCESS', cards, connections })
            })
            .catch(error => dispatch({ type: 'CARD_QUERY_FAILURE', error }))
    }
}

export const getCountryByIP = () => dispatch => {
    return fetch(`${API_BASE}/utilities/country-by-ip`)
        .then(res => (res.ok ? res : Promise.reject(res)))
        .then(res => res.json())
}

// Re-export legacy reducer and action types after imports to satisfy import-order lint
// Removed circular re-exports

// Basic reducer for personal slice
const initialState = {
    loading: false,
    error: null,
    data: null,
    qrCodes: []
}

const personalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'personal/qrCodeList':
            return {
                ...state,
                qrCodes: action.payload.qrCodes || []
            }
        case 'personal/qrCodeCreate':
            return {
                ...state,
                qrCodes: [...(state.qrCodes || []), action.payload.qrCode]
            }
        case 'personal/qrCodeUpdate':
            return {
                ...state,
                qrCodes: (state.qrCodes || []).map(qr =>
                    qr.id === action.payload.qrCode.id ? action.payload.qrCode : qr
                )
            }
        case 'personal/qrCodeDelete':
            return {
                ...state,
                qrCodes: (state.qrCodes || []).filter(qr => qr.id !== action.payload.id)
            }
        default:
            return state
    }
}

export default personalReducer

